module.exports = __webpack_public_path__ + "img/jicheng (1).0f8dd31a.png";